// A wrapper for <Route> that redirects to the login
import { authTokenExists } from "@fxid/shared";
import React, { JSX } from "react";
import { Navigate } from "react-router-dom";

interface Props {
	children: JSX.Element;
	path: string;
}

export const AuthRoute = ({ children, path }: Props) => {
	const isAuthed = authTokenExists();
	const message = "Please log in to view this page";

	if (isAuthed) {
		return children;
	}

	return (
		<Navigate
			to="/"
			state={{
				message,
				requestedPath: path
			}}
		/>
	);
};
